import {inject, Injectable, REQUEST} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {getLangFromCookies} from '../../utils/helper';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  request = inject(REQUEST, {optional: true})

  constructor(
    private translate: TranslateService,
  ) {
  }

  init() {
    const cookieLang = this.request?.headers.get('cookie');
    const lang = getLangFromCookies(cookieLang) || this.getClientCookieLang() || 'en';
    this.translate.use(lang);
  }

  private getClientCookieLang(): string {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp('(^| )appLang=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
}
